import { FC } from "react";
import { SectionContainerStyled } from './styled'
import { ContainerPageProps } from "../../../design-system/domain";

const ContainerPage: FC<ContainerPageProps> = ({ children }) => (
  <SectionContainerStyled.Container>{children}</SectionContainerStyled.Container>
)

export default ContainerPage;